<form class="horizontal-form" [formGroup]="form" (ngSubmit)="submit()">
  <div class="modal-header">
    <h4 class="modal-title pull-left">New Contract</h4>
    <button
      type="button"
      class="btn-close pull-right"
      aria-label="Close"
      (click)="closeModal()"
      (keydown.enter)="closeModal()"></button>
  </div>
  <div class="modal-body">
    @if (showFormInvalid()) {
      <div class="alert alert-danger" role="alert">
        <i class="fa fa-lg fa-warning"></i>
        {{
          form.errors.global || 'An error occurred after submitting the form.'
        }}
      </div>
    }
    <div class="mb-3 row">
      <label for="domain" class="col-md-2 col-form-label">Domain</label>
      <div class="col">
        <domain-selector
          class="form-control-holder"
          [class.is-invalid]="showFieldInvalid('domain')"
          formControlName="domain"
          [placeholder]="'Select domain'"></domain-selector>
        <div class="invalid-feedback">Please select a domain.</div>
      </div>
    </div>
    <div class="mb-3 row">
      <label class="col-md-2 col-form-label">Contract Type</label>
      <div class="col">
        <!-- old -->
        <!-- <select class="form-select" formControlName="contractType" [class.is-invalid]="showFieldInvalid('contractType')" required>
        <option [ngValue]="null" disabled selected hidden>Select a contract type</option>
        <ng-container *ngIf="availableTypes$ | async as types">
          <option *ngFor="let type of types" [ngValue]="type" [title]="type.description">{{ type.name }}</option>
        </ng-container>
      </select> -->

        <option-select
          [spaceAsWildCard]="true"
          [options$]="availableTypesAsOptions$"
          placeholder="Select a contract type"
          formControlName="contractType"
          [class.is-invalid]="showFieldInvalid('contractType')">
        </option-select>

        <div class="invalid-feedback">Please select a contract type.</div>
      </div>
    </div>
  </div>
  @if (loading$ | async) {
    <loader-line></loader-line>
  }
  <div class="modal-footer">
    <div class="form-submit">
      <button
        type="submit"
        class="btn btn-primary"
        [disabled]="form.invalid || submitting">
        <span
          (click)="submitHelper($event)"
          (keydown.enter)="submitHelper($event)"
          ><i class="fa fa-check">&nbsp;</i>Create</span
        >
      </button>
      <button
        type="button"
        class="btn btn-secondary"
        (click)="reset()"
        (keydown.enter)="reset()">
        <i class="fa fa-ban"></i> Reset
      </button>
    </div>
  </div>
</form>
